import { z } from 'zod';

const getUpdateFormValidationSchema = z.object({
  firstName: z
    .string()
    .min(1, { message: 'First name is required' })
    .max(50, { message: 'First name must be less than 50 characters' }),
  lastName: z
    .string()
    .min(1, { message: 'Last name is required' })
    .max(50, { message: 'Last name must be less than 50 characters' }),
  email: z
    .string()
    .min(1, { message: 'Email is required' })
    .email({ message: 'Please enter a valid email address' }),
  userType: z
    .string()
    .min(1, {
      message: 'Please select whether you are a patient or caregiver',
    }),
  woundLocation: z
    .array(z.string())
    .min(1, { message: 'Please select where your wound is located' }),
  address: z.string().optional(),
  address2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  termsAgree: z.boolean().refine((val) => val === true, {
    message: 'You must agree to receive communications to proceed',
  }),
});



export { getUpdateFormValidationSchema };
